import labels from "../utils/labels";
import { AdjustmentStep, ContingencyPreset } from "../types/contingency";

// Mirrors the backend's start-optimization: ticking expanded transport runs
// the "_WITH_EXPANDED_TRANSPORTATION" preset, so its values are the ones to show.
export const getAdjustmentLines = (
  presets: ContingencyPreset[],
  step: AdjustmentStep,
  isTransportExpanded: boolean,
): string[] => {
  const level = isTransportExpanded
    ? `${step}_WITH_EXPANDED_TRANSPORTATION`
    : step;
  const preset = presets.find((p) => p.level === level);
  if (!preset) return [];

  const reductionPercent = Math.round(
    (1 - preset.durationAdjustmentFactor) * 100,
  );
  const lines = [
    reductionPercent > 0
      ? labels.reducesVisitDuration(reductionPercent)
      : labels.doesNotReduceVisitDuration,
    preset.timeWindowExpansionMinutes > 0
      ? labels.expandsTimeWindow(preset.timeWindowExpansionMinutes)
      : labels.doesNotExpandTimeWindow,
  ];
  if (preset.rulesetComment) lines.push(preset.rulesetComment);
  return lines;
};
